import { Navigate } from 'react-router-dom';

import { useDefaultRedirect } from 'app/hooks';

const DefaultPages = () => {
	const defaultRedirect = useDefaultRedirect();

	return <Navigate to={defaultRedirect} replace />;
};

export default DefaultPages;
